exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inquiry-view {\n  margin-top: 20px; }\n\ntextarea {\n  resize: none;\n  background-color: #f5f5f5 !important;\n  color: #444 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/contact-inquiries/contact-inquiry-view/contact-inquiry-view.component.scss
// module id = ../../../../../src-admin/app/components/contact-inquiries/contact-inquiry-view/contact-inquiry-view.component.scss
// module chunks = main